"use client"

import { useEffect, useState } from "react"
import { perfMonitorEnhanced } from "@/app/lib/performance/performance-monitor-enhanced"

interface ServerPerformanceData {
  measurements: Array<{
    name: string
    duration: number
  }>
  totalTime: number
}

interface ClientPerformanceLoggerProps {
  segments: string[]
  perfilsCount: number
  serverPerformanceData?: ServerPerformanceData
}

export function ClientPerformanceLogger({
  segments,
  perfilsCount,
  serverPerformanceData,
}: ClientPerformanceLoggerProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted) return

    // Set page data for performance monitoring
    perfMonitorEnhanced.setPageData(segments.length, perfilsCount)

    // If we have server performance data, inject it into the client monitor
    if (serverPerformanceData) {
      // Add server measurements to client monitor
      serverPerformanceData.measurements.forEach((measurement) => {
        perfMonitorEnhanced.addServerMeasurement(measurement.name, measurement.duration)
      })
    }

    // Wait a bit for all client-side operations to complete
    const timer = setTimeout(() => {
      perfMonitorEnhanced.logClientSummary()
    }, 100)

    return () => clearTimeout(timer)
  }, [mounted, segments.length, perfilsCount, serverPerformanceData])

  // Invisible component
  return null
}
